<header>
    <h3>{{ 'pages.profile.addresses.changeSubType' | translate }}</h3>
    <button mat-icon-button aria-label="Close" (click)="cancel()">
        <span class="icon-close"></span>
    </button>
</header>

<div class="dialog-content">
    <label class="input-label">{{ 'pages.profile.addresses.changeSubTypePrompt' | translate }}</label>
    <select class="subtype-select" [formControl]="subTypeControl">
        <option value="RESIDENT">{{ 'pages.residences.subType.resident' | translate }}</option>
        <option value="NONRESIDENT">{{ 'pages.residences.subType.nonResident' | translate }}</option>
    </select>
</div>

<footer>
    <button
        class="bciti-button bciti-button--blue-inversed"
        (click)="cancel()">
        {{ 'pages.residences.reviewDialog.cancelButton' | translate }}
    </button>
    <button
        class="bciti-button bciti-button--blue"
        [disabled]="subTypeControl.value === data.currentSubType"
        (click)="confirm()">
        {{ 'pages.profile.addresses.changeSubTypeButton' | translate }}
    </button>
</footer>
